import { useState, FormEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
// import { Button } from '../components/Button';
// import { ParticleBackground } from '../components/ParticleBackground';
import { User, Lock } from 'lucide-react';
import styles from './AuthView.module.css';

export default function LoginView() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { login, error, clearError } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    clearError();
    setIsSubmitting(true);

    try {
      // Backend still uses email, but we show it as username
      await login(username, password);
      navigate('/');
    } catch (error) {
      // Error is handled by AuthContext
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.glassCard}>
        {/* Left Side - Form */}
        <div className={styles.formSection}>
          <div className={styles.logo}>
            {/* Logo Image */}
            <img
              src="/logo.png"
              alt="Logo"
              className={styles.logoImage}
              onError={(e) => {
                e.currentTarget.style.display = 'none';
                e.currentTarget.nextElementSibling?.classList.remove(styles.hidden);
              }}
            />
            {/* Fallback */}
            <div className={`${styles.logoFallback} ${styles.hidden}`}>
              <div className={styles.logoIcon}>C</div>
              <span className={styles.logoText}>CTC Calc</span>
            </div>
          </div>

          <div className={styles.titleGroup}>
            <p className={styles.subtitle}>Iniciar Sesión</p>
          </div>

          <form onSubmit={handleSubmit} className={styles.form}>
            {error && (
              <div className={styles.error}>
                <Lock size={16} />
                {error}
              </div>
            )}

            <div className={styles.inputGroup}>
              <div className={styles.inputWrapper}>
                <input
                  id="username"
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                  className={styles.input}
                  placeholder="Usuario"
                  autoComplete="username"
                />
                <User className={styles.inputIcon} size={20} />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <div className={styles.inputWrapper}>
                <input
                  id="password"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  className={styles.input}
                  placeholder="Contraseña"
                  autoComplete="current-password"
                  minLength={8}
                />
                <Lock className={styles.inputIcon} size={20} />
              </div>
            </div>

            <div className={styles.forgotPassword}>
              <a href="#" className={styles.forgotLink}>¿Olvidaste tu contraseña?</a>
            </div>

            <button
              type="submit"
              className={styles.button}
              disabled={isSubmitting}
            >
              {isSubmitting ? 'Iniciando sesión...' : 'Iniciar Sesión'}
            </button>
          </form>

          {/* Footer removed for security (no public registration) */}
        </div>

        {/* Right Side - Visual (Empty as requested, just image) */}
        <div className={styles.visualSection} />
      </div>
    </div>
  );
}
